const CloseIcon = () => {
  return (
    <div className={'close-icon'}>
      <div />
    </div>
  );
};

export default CloseIcon;
